import { IntegrationsMarketplaceAppContainerWebComponent } from './component/IntegrationsMarketplaceAppContainerWebComponent';
import { WEB_COMPONENT_INTEGRATIONS_MARKETPLACE_APP_CONTAINER } from '../../webcomponents.constants';

export { IntegrationsMarketplaceAppContainerWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRATIONS_MARKETPLACE_APP_CONTAINER,
  IntegrationsMarketplaceAppContainerWebComponent
);
